const currentCustomer = require('./customer');
const definition = require('./customers/' + currentCustomer).default;
export default definition;
